declare global {
  interface Window {
    IS_MOBILE_APP?: boolean;
  }
}

/**
 * Synchronous check for native app WebView (same signal as {@link useIsMobileApp}).
 * Safe for non-React code such as {@link trackEvent}.
 */
export function isMobileAppRuntime(): boolean {
  return typeof window !== "undefined" && window.IS_MOBILE_APP === true;
}
